import { type Cue, isAboutWords, isCallCue, isPersonal } from "./cue.ts";
import { loudnessOf, type SoundSettings } from "./settings.ts";

export const RECENTLY_TYPED = 8000;

export const DUCKED = 0.3;

export type Hearing = {
  settings: SoundSettings;

  mine: boolean;

  focused: boolean;

  typedAgo: number | null;

  speaking: boolean;

  silent: boolean;
};

export type Verdict = { play: boolean; why: string; gain: number };

const MINE_MAY_SOUND = new Set<Cue>(["youJoined", "sendFailed"]);

function passesMaster(cue: Cue, settings: SoundSettings): string | null {
  if (settings.master === "off") return "sound is off";
  if (settings.master === "mentions" && !isPersonal(cue) && !isCallCue(cue)) {
    return "only what is addressed to you";
  }
  return null;
}

export function mayPlay(cue: Cue, hearing: Hearing): Verdict {
  const quiet = { play: false, gain: 0 };

  if (hearing.silent) return { ...quiet, why: "this device is silent" };

  const master = passesMaster(cue, hearing.settings);
  if (master) return { ...quiet, why: master };
  if (isCallCue(cue) && !hearing.settings.calls) return { ...quiet, why: "call sounds are off" };

  if (hearing.mine && !MINE_MAY_SOUND.has(cue)) return { ...quiet, why: "you did that" };

  const typing = hearing.typedAgo !== null && hearing.typedAgo < RECENTLY_TYPED;
  if (isAboutWords(cue) && hearing.focused && typing) {
    return { ...quiet, why: "you are writing in that conversation" };
  }

  const gain = loudnessOf(hearing.settings) * (hearing.speaking ? DUCKED : 1);
  return { play: true, why: "", gain };
}
